(function () {
    'use strict';

    var app = angular.module('inoApp');

    // Do not add any dependencies to this service, leave it as lightweight as possible.
    // If we need to add, let's say, profile information on startup, do it in the authService.activate method to keep dependencies to a minimum.

    app.factory('userService', ['storageService', userServiceFactory]);

    function userServiceFactory(storageService) {
        var sessionCurrentUserKey = 'sessionCurrentUser';

        var service = {
            clear: clear,
            currentUser: {
                uniqueId: '',
                profile: {
                    email: '',
                    firstName: '',
                    lastName: ''
                },
                tokens: {
                    accessToken: '',
                    identityToken: '',
                    refreshToken: ''
                }
            },
            isAuthenticated: isAuthenticated,
            persist: persist,
            setProfile: setProfile,
            setTokens: setTokens
        };

        activate();

        return service;

        function activate() {
            resetCurrentUser();

            // Get the stored bearer token if it exists
            var sessionUser = storageService.getItem(sessionCurrentUserKey);
            if (sessionUser) {
                setProfile(sessionUser.uniqueId, sessionUser.profile.email, sessionUser.profile.firstName, sessionUser.profile.lastName);
                setTokens(sessionUser.tokens.accessToken, sessionUser.tokens.identityToken, sessionUser.tokens.refreshToken);
            }
        }

        function clear() {
            resetCurrentUser();
            storageService.removeItem(sessionCurrentUserKey);
        }

        function isAuthenticated() {
            return !!service.currentUser.uniqueId;
        }

        function persist() {
            storageService.setItem(sessionCurrentUserKey, service.currentUser);
        }

        function resetCurrentUser() {
            service.currentUser.uniqueId = '';
            service.currentUser.profile.email = '';
            service.currentUser.profile.firstName = '';
            service.currentUser.profile.lastName = '';
            service.currentUser.tokens.accessToken = '';
            service.currentUser.tokens.identityToken = '';
            service.currentUser.tokens.refreshToken = '';
        }

        function setProfile(uniqueId, email, firstName, lastName) {
            service.currentUser.uniqueId = uniqueId;
            service.currentUser.profile.email = email;
            service.currentUser.profile.firstName = firstName;
            service.currentUser.profile.lastName = lastName;
        }

        function setTokens(accessToken, identityToken, refreshToken) {
            service.currentUser.tokens.accessToken = accessToken;
            service.currentUser.tokens.identityToken = identityToken;
            service.currentUser.tokens.refreshToken = refreshToken;
        }
    }
})();